import ResponseModel from "../../models/response.model";
import axiosSetup from "../../utils/axiosSetup";

export const getStoreStocksApi = async (params: {
  warehouseId?: string;
  page: number;
  limit: number;
  search?: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/store/stock";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getFactoriesApi = async (): Promise<ResponseModel> => {
  try {
    const path = "/factory/store/factories";
    const res = await axiosSetup.get(path);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getThirdPartyRequestsApi = async (params: {
  page: number;
  limit: number;
  status?: string;
  vendorId?: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/store/third-party-requests";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const getThirdPartyInwardBatchesApi = async (params: {
  requestId: string;
}): Promise<ResponseModel> => {
  try {
    const path = `/factory/store/third-party-inward/${params.requestId}/batches`;
    const res = await axiosSetup.get(path);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export interface IThirdPartyOutwardPayload {
  vendorId: string;
  sendingTransportCost?: number;
  sendingExtraCost?: number;
  remark?: string;
  productId?: string;
  rawMaterialId?: string;
  items: {
    rawMaterialId: string;
    quantity: number;
    unit: string;
  }[];
}

export const createThirdPartyOutwardApi = async (
  payload: IThirdPartyOutwardPayload,
): Promise<ResponseModel> => {
  try {
    const path = "/factory/store/third-party-outward"; // Adjust endpoint path according to your storeRouter mounting path
    const res = await axiosSetup.post(path, payload);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export interface IInwardItemPayload {
  itemId: string;
  itemType: "material" | "product";
  quantity: number;
  unit: string;
}

export interface ICreateThirdPartyInwardPayload {
  thirdPartyRequestId: string;
  productionCost?: number;
  receivingTransportCost?: number;
  receivingExtraCost?: number;
  inwardItems: IInwardItemPayload[];
  invoiceNo: string;
  orderDate: string;
  recieveDate: string;
  remark?: string;
}

export const createThirdPartyInwardApi = async (
  payload: ICreateThirdPartyInwardPayload,
): Promise<ResponseModel> => {
  const response = await axiosSetup.post(
    "/factory/store/third-party-inward",
    payload,
  );
  return response.data;
};

export const completeThirdPartyInwardApi = async (payload: {
  thirdPartyRequestId: string;
  // Optional costs incurred at finalization time, on top of what was
  // already recorded per-batch via CreateThirdPartyInward
  productionCost?: number;
  receivingTransportCost?: number;
  receivingExtraCost?: number;
}): Promise<ResponseModel> => {
  const response = await axiosSetup.post(
    "/factory/store/third-party-inward/complete",
    payload,
  );
  return response.data;
};

export const cancelThirdPartyRequestApi = async (
  id: string,
): Promise<ResponseModel> => {
  const response = await axiosSetup.patch(
    "/factory/store/third-party-cancel/" + id,
  );
  return response.data;
};
